var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H2.99997C2.46973 1.00054 1.96134 1.21148 1.58646 1.58646C1.21144 1.96134 1.00051 2.46973 1 2.99997V15C1.00054 15.5303 1.21148 16.0387 1.58646 16.4135C1.96134 16.7886 2.46973 16.9995 2.99997 17H15C15.5303 16.9995 16.0387 16.7885 16.4135 16.4135C16.7886 16.0387 16.9995 15.5303 17 15V2.99997C16.9995 2.46973 16.7885 1.96134 16.4135 1.58646C16.0387 1.21144 15.5303 1.00051 15 1ZM16.2 15C16.1996 15.3182 16.0732 15.6231 15.8482 15.8481C15.6232 16.0731 15.3182 16.1996 15 16.2H2.99997C2.68175 16.1996 2.37678 16.0731 2.1518 15.8481C1.92682 15.6231 1.80037 15.3182 1.79996 15V2.9999C1.80036 2.68168 1.92679 2.37672 2.1518 2.15173C2.37681 1.92675 2.68176 1.8003 2.99997 1.79989H15C15.3183 1.80029 15.6232 1.92672 15.8482 2.15173C16.0732 2.37674 16.1996 2.68169 16.2 2.9999V15Z",
    fill: "#3ADB76",
    stroke: "#3ADB76",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 8.99996C10.6 9.88361 9.88361 10.6 8.99996 10.6C8.11631 10.6 7.3999 9.88361 7.3999 8.99996C7.3999 8.11631 8.11631 7.3999 8.99996 7.3999C9.88361 7.3999 10.6 8.11631 10.6 8.99996Z",
    fill: "#3ADB76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59988 4.99982C6.59988 5.88347 5.88347 6.59988 4.99982 6.59988C4.11617 6.59988 3.3999 5.88347 3.3999 4.99982C3.3999 4.11617 4.11617 3.3999 4.99982 3.3999C5.88347 3.3999 6.59988 4.11617 6.59988 4.99982Z",
    fill: "#3ADB76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5999 13C14.5999 13.8836 13.8836 14.5999 13 14.5999C12.1163 14.5999 11.3999 13.8836 11.3999 13C11.3999 12.1163 12.1163 11.3999 13 11.3999C13.8836 11.3999 14.5999 12.1163 14.5999 13Z",
    fill: "#3ADB76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.161c9df607b89ef4cd4f925c7ba5d89b.svg";
export { ForwardRef as ReactComponent };